<script lang="ts">
  import { t, T } from 'svelte-i18n-lingui';

  export let type = 'default' // default | product | universe
</script>


<div class="compensation-banner {type}">
  <div class="compensation-banner__inner">
    <div class="compensation-banner__content">
      <h2 class="compensation-banner__title head-3">{$t`At bixoto we compensate for the CO2 generated by each order!`}</h2>
      <div class="compensation-banner__desc lead-1">
        <T msg="Together with # we plant trees to offset the CO2 generated by each and every one of our products sold.">
          <b>HundredTrees</b>
        </T>
      </div>
    </div>

    <img
      class="compensation-banner__img"
      src="/images/sustainability.png"
      height="204"
      width="272"
      alt="En bixoto compensamos el CO2 generado"
      title="Banner sostenibilidad. Compensación CO2 generado"
    >
  </div>
</div>


<style lang="scss">
  .compensation-banner {
    width: 100%;
    overflow: hidden;

    &.universe {
      .compensation-banner {
        &__inner {
          background: linear-gradient(90deg, var(--univ-main), #D6F4EC);
        }
      }
    }

    &.product {
      img {
        display: none;
      }
    }

    &__img {
      margin: -10px -20px -10px 15px;
      height: 100%;
      width: 120px;

      @media (min-width: 481px) {
        width: 160px;
        margin: -10px -25px -10px 20px;
      }

      @media (min-width: 769px) {
        width: 250px;
        margin: -10px -40px -10px 30px;
      }
    }

    &__inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      background: #D6F4EC;

      @media (min-width: 481px) {
        padding: 25px;
      }

      @media (min-width: 769px) {
        padding: 40px;
      }
    }

    &__content {
      max-width: 700px;
    }

    &__title {
      font-weight: 900;
      line-height: 1.2;
      margin-bottom: 20px;

      @media (max-width: 480px) {
        font-size: 16px;
        margin-bottom: 10px;
      }
    }

    &__desc {
      @media (max-width: 480px) {
        font-size: 12px;
      }
    }
  }
</style>
